import { useState } from "react";
import { ActionButton, useTheme } from "@fluentui/react";
import { useTimeoutFn } from "react-use";


const Footer = ({ onGrid = true }) => {
  const theme = useTheme();
  // Allow users to manage their cookie consent preferences. Not all regions
  // require consent, and the cookie library will do a no-op if the consent dialog is
  // launched in a non-required region. So check for requirements before rendering the button.
  // Defaulting to true is primarily to satisfy the compliance test, to ensure
  // that manage button is rendered on first render, while the consent library
  // may still be loading.
  const [isConsentRequired, setIsConsentRequired] = useState(true);

  useTimeoutFn(() => {
    // Cookie consent is determined regionally. If it can't be determined, default
    // to requiring consent.
    const consent = window?.siteConsent?.isConsentRequired;
    setIsConsentRequired(consent === undefined ? true : consent);
  }, 100);

  const manageConsent = isConsentRequired ? (
    // Button to launch consent form, styled to mimic the UHF links
    <ActionButton
      onClick={() => window.siteConsent.manageConsent()}
      ariaDescription="Launch cookie consent form"
      style={{ fontSize: "11px", padding: "0", color: "#616161", height: "0" }}
    >
      Manage cookies
    </ActionButton>
  ) : null;

  return (
    <footer
      style={{
        background: `linear-gradient(${theme.palette.themeDark}, ${theme.palette.neutralPrimary} 75%)`,
        color: theme.palette.white,
        display: "flex",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          // display: "grid",
          // gridTemplateColumns: "2fr 2fr", 
          gap: "1rem",
          alignItems: "center",
          maxWidth: '1140px',
          width: '100%',
        }}
      >
        <div>
        </div>
        <img
          src="./images/loghi-EC.png"
          style={{
            maxHeight: "60px",
            display: "block",
            marginLeft: "auto",
            marginRight: "auto"
          }}
        />
      </div>
    </footer>
  );
};

export default Footer;
